import { HeroSection } from '../BabyRegistryChecklist/components'
import { SyncChecklistSection } from '../BabyRegistryChecklist/components/SyncChecklistSection/SyncChecklistSection'

export const ChecklistAcqex = () => (
  <>
    <HeroSection />
    <SyncChecklistSection />
  </>
)
